export default __webpack_public_path__ + "static/company_prfl_chart-823dcfb4330c9073a940a73c51c47ead.svg";